module.exports = __webpack_public_path__ + "img/20220805141738.86d500e6.jpg";